import i18n from 'i18next'; import { Dialog, DialogContent, DialogTitle, IconButton, makeStyles, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
}));

const CompanyTypeDescribeModal = (props) => {
  const { open, onClose } = props;

  const classes = useStyles();

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      className="tp-how-make-favourite-group__modal"
    >

      <DialogTitle
        onClose={onClose}
      >

        <b>{i18n.t('CompanyTypeDescribeModal.sat\u0131c\u0131_tedarik\xE7i_firma_se\xE7ene\u011Fi_nedir')}</b>
        <IconButton
          aria-label={i18n.t('CompanyTypeDescribeModal.close')}
          className={classes.closeButton}
          onClick={onClose}
        >

          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          <p><strong>{i18n.t('CompanyTypeDescribeModal.say\u0131n_firmam\u0131z')}</strong></p>
          <p>
            <strong>{i18n.t('CompanyTypeDescribeModal.joobid')}</strong>
            {' '}
            {i18n.t('CompanyTypeDescribeModal.platformunda')}

            {' '}
            <strong>{i18n.t('CompanyTypeDescribeModal.tedarik\xE7i_firma')}</strong>
            {' '}
            {i18n.t('CompanyTypeDescribeModal.olarak_listelenmek_ve')}

            {' '}
            <strong>{i18n.t('CompanyTypeDescribeModal.al\u0131m_taleplerine')}</strong>
            {' '}
            {i18n.t('CompanyTypeDescribeModal.teklif_vermek_istiyor_iseniz_a\u015Fa\u011F\u0131da_ki_')}

            {' '}
            <strong>{i18n.t('CompanyTypeDescribeModal.i\u015Faretleyiniz')}</strong>
            {' '}
            {i18n.t('CompanyTypeDescribeModal.platformu_sadece')}

            {' '}
            <strong>{i18n.t('CompanyTypeDescribeModal.sat\u0131n_alma_teklifleri')}</strong>
            {' '}
            {i18n.t('CompanyTypeDescribeModal.i\xE7in_kullanacak_iseniz_kutucu\u011Fu')}

            {' '}
            <strong>{i18n.t('CompanyTypeDescribeModal.bo\u015F_b\u0131rak\u0131n\u0131z')}</strong>
          </p>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyTypeDescribeModal;

CompanyTypeDescribeModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};
